// extracted by mini-css-extract-plugin
export default {"ManualCompleteStaffReviewBanner":"LyK9tf28yR"};